import PaidBenefits from 'pages/benefits/containers/components/PaidBenefit';
import BenefitsSlider from 'pages/benefits/containers/components/benefits';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const BenefitAndAddOn = () => {
  return (
    <div className="block">
      <PaidBenefits />
      <BenefitsSlider />
    </div>
  );
};

export default BenefitAndAddOn;
